/**
 * @file コンポーネント：フル動画ページ編集モーダル スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledModal = styled.div``;

export const StyledModalTime = styled.div`
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
`;
